export const defaultLabelId = (baseId: string): string => `${baseId}-label`;

export const defaultErrorId = (baseId: string): string => `${baseId}-error`;

export const defaultContainerId = (baseId: string): string => `${baseId}-container`;

export const defaultTooltipId = (baseId: string): string => `${baseId}-tooltip`;

export const defaultTooltipToggleId = (baseId: string): string =>
  `${baseId}-tooltip-toggle`;

export const getFieldIdFromTooltipToggleId = (baseId: string): string =>
  baseId.substring(baseId.indexOf('.') + 1, baseId.indexOf('-tooltip-toggle'));

export const defaultExplanatoryTextId = (baseId: string): string =>
  `${baseId}-explanatory`;

export const joinIds = (...ids: string[]): string => ids.join(' ');
